/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 403:
/***/ (() => {

// Add passive event to improve performance
// https://developer.mozilla.org/fr/docs/Web/API/EventTarget/addEventListener#Am%C3%A9lioration_des_performances_de_d%C3%A9filement_avec_les_%C3%A9couteurs_passifs
window.supportPassive = false;

try {
  window.addEventListener(
    'test',
    null,
    Object.defineProperty({}, 'passive', {
      // eslint-disable-next-line getter-return
      get() {
        window.supportPassive = { passive: false };
      },
    })
  );
} catch (err) {
  // eslint-disable-next-line no-console
  console.log('SupportPassive si not supported with this browser.');
}


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";

// EXTERNAL MODULE: ./src/js/helpers.js
var helpers = __webpack_require__(403);
;// ./src/js/product.js
class Product {
  init() {
    this.product = document.querySelector('.product-info');
    if (this.product) {
      this.detectUnavailableProduct();
    }
  }

  detectUnavailableProduct() {
    let submitButton = this.product.querySelector(
      '.buy-buttons button[type="submit"]'
    );
    if (submitButton) {
      if (submitButton.classList.contains('button--subdued') !== true) {
        this.hideButton();
      }
    }

    let switchers = this.product.querySelectorAll('.color-swatch');
    for (let switcher of switchers) {
      switcher.addEventListener('click', () => {
        if (
          switcher.classList.contains('color-swatch--not-available') !== true
        ) {
          this.hideButton();
        } else {
          this.revealButton();
        }
      });
    }
  }

  hideButton() {
    const bisTrigger = this.product.querySelector('#BIS_trigger');
    if (bisTrigger) {
      bisTrigger.style.display = 'none';
    }
  }

  revealButton() {
    const bisTrigger = this.product.querySelector('#BIS_trigger');
    if (bisTrigger) {
      bisTrigger.style.display = 'block';
    }
  }
}

;// ./src/js/CollectionDescription.js
class CollectionDescription {
  collectionDescription = null;
  collectionDescriptionButton = null;

  init() {
    this.collectionDescription = document.querySelector(
      '.collection__description-excerpt'
    );

    this.collectionDescriptionButton = document.querySelector(
      '.collection__description-button'
    );

    if (this.collectionDescription && this.collectionDescriptionButton) {
      this.toggleButtonContent();
      this.collectionDescriptionButton.addEventListener('click', () => {
        this.toggleExcerpt();
      });
    }
  }

  toggleExcerpt = () => {
    this.collectionDescription.classList.toggle(
      'collection__description-excerpt--hidden'
    );

    this.toggleButtonContent();
  };

  toggleButtonContent = () => {
    const buttonContent =
      this.collectionDescriptionButton.getElementsByTagName('span');
    if (
      this.collectionDescription.classList.contains(
        'collection__description-excerpt--hidden'
      )
    ) {
      buttonContent[1].style.display = 'none';
      buttonContent[0].style.display = 'inline-block';
    } else {
      buttonContent[0].style.display = 'none';
      buttonContent[1].style.display = 'inline-block';
    }
  };
}

;// ./src/js/CheckboxTermsCart.js
class CheckboxTermsCart {
  constructor() {
    this.formSelector = '.cart-form-js';
    this.checkBoxSelector = '#checkbox-terms-cond-cart';
    this.submitSelector = '.cart-form-js button[type="submit"]';
    this.checkBoxLabel = '.checkbox-terms-cart__label';
    this.cartDrawerSelector = '.cart-drawer';
  }

  init() {
    this.manageCheckBox();

    window.addEventListener('variant:add', () => {
      this.manageCheckBox();
    });

    window.addEventListener('cart:change', () => {
      this.manageCheckBox();
    });

    const cartDrawer = document.querySelector(this.cartDrawerSelector);
    if (!cartDrawer) return;

    cartDrawer.addEventListener('toggle', () => {
      if (cartDrawer.open) {
        this.manageCheckBox();
      }
    });
  }

  manageCheckBox = () => {
    const forms = document.querySelectorAll(this.formSelector);
    if (!forms.length > 0) return;

    forms.forEach((form) => {
      const checkbox = form.querySelector(this.checkBoxSelector);
      const submitButton = form.querySelector(this.submitSelector);
      const checkboxLabel = form.querySelector(this.checkBoxLabel);

      if (!checkbox || !submitButton || !checkboxLabel) return;

      // Delete old eventListener for avoid errors
      checkboxLabel.removeEventListener('click', this.handleCheckboxLabelClick);
      checkbox.removeEventListener('change', this.handleCheckboxChange);

      checkboxLabel.addEventListener('click', this.handleCheckboxLabelClick);
      checkbox.addEventListener('change', this.handleCheckboxChange);
    });
  };

  handleCheckboxLabelClick = (e) => {
    if (e.target.tagName !== 'A') {
      e.preventDefault();
      const checkbox = e.currentTarget
        .closest(this.formSelector)
        .querySelector(this.checkBoxSelector);
      const submitButton = e.currentTarget
        .closest(this.formSelector)
        .querySelector(this.submitSelector);

      if (checkbox.checked) {
        checkbox.checked = false;
        submitButton.setAttribute('disabled', '');
      } else {
        checkbox.checked = true;
        submitButton.removeAttribute('disabled');
      }
    }
  };

  handleCheckboxChange = (e) => {
    const checkbox = e.target;
    const submitButton = checkbox
      .closest(this.formSelector)
      .querySelector(this.submitSelector);

    checkbox.checked
      ? submitButton.removeAttribute('disabled')
      : submitButton.setAttribute('disabled', '');
  };
}

;// ./src/js/PreorderProduct.js
class PreorderProduct {
  constructor() {
    this.buyButtonsSelector = '.product-info__buy-buttons';
    this.addToCartButtonSelector = '.buy-buttons__add-to-cart div';
    this.initialDeliverySelector = '.product-info .delivery-widget__auto';
    this.offerPreOrderTitleSelector =
      '.product-info .offer--pre-order .offer__title';
    this.inventorySelector = '.product-info__inventory';
  }

  init = () => {
    this.addToCartButton = document.querySelector(this.addToCartButtonSelector);
    if (!this.addToCartButton) return;

    this.offerPreOrderTitle = document.querySelector(
      this.offerPreOrderTitleSelector
    );
    if (!this.offerPreOrderTitle) return;

    this.inventory = document.querySelector(this.inventorySelector);
    if (!this.inventory) return;

    this.initialDelivery = document.querySelector(this.initialDeliverySelector);
    if (!this.initialDelivery) return;

    this.buyButtons = document.querySelector(this.buyButtonsSelector);
    if (!this.buyButtons) return;

    this.newDiv = document.createElement('p');
    this.newDiv.className = 'product-info__preorder-delay';

    this.currentVariantIsPreorder(window.currentVariant);

    document.addEventListener('variant:change', (e) => {
      this.currentVariantIsPreorder(e.detail.variant.id);
    });
  };

  currentVariantIsPreorder = (variantId) => {
    const isPreorder = window.variantPreorder[variantId].preorder ?? false;
    const title =
      window.variantPreorder[variantId].title ?? window.defaultOfferTitle;

    if (isPreorder) {
      this.addToCartButton.textContent =
        window.themeVariables.strings.preOrderButton;
      this.initialDelivery.style.display = 'none';
      this.inventory.style.display = 'none';
      this.newDiv.style.display = 'block';
      this.newDiv.textContent = title;
      this.buyButtons.before(this.newDiv);
    } else {
      this.addToCartButton.textContent =
        window.themeVariables.strings.addToCartButton;
      this.initialDelivery.style.display = 'block';
      this.inventory.style.display = 'block';
      this.newDiv.style.display = 'none';
    }

    if (this.offerPreOrderTitle.textContent !== title) {
      this.offerPreOrderTitle.textContent = title;
    }
  };
}

;// ./src/js/QuickBuy.js
class QuickBuy {
  constructor() {
    this.quickBuySelector = '.quick-buy-drawer__info';
    this.addToCartButtonSelector = '.buy-buttons__add-to-cart';
  }

  init = () => {
    document.addEventListener('variant:change', (e) => {
      this.handleQuickBuyElement(e.detail.variant.id);
    });
  };

  handleQuickBuyElement = (variantId) => {
    const isPreorder = window.variantPreorder[variantId].preorder ?? false;

    const quickBuy = document.querySelector(this.quickBuySelector);
    if (!quickBuy) return;

    const buttonText = quickBuy.querySelector(
      `${this.addToCartButtonSelector} div`
    );
    if (!buttonText) return;

    if (isPreorder) {
      buttonText.textContent = window.themeVariables.strings.preOrderButton;
    } else {
      buttonText.textContent = window.themeVariables.strings.addToCartButton;
    }
  };
}

;// ./src/js/ProductCard.js
class ProductCard {
  constructor() {
    this.productCardsSelector = '.product-card';
    this.swatchButtonsSelector = '.product-card__swatch-list .color-swatch';
    this.buttonSelector =
      '.product-card__quick-buy .product-card__desktop-quick-buy-button > div:first-child';
  }

  init = () => {
    const productCards = document.querySelectorAll(this.productCardsSelector);
    if (!productCards.length > 0) return;

    productCards.forEach((productCard) => {
      const swatchButtons = productCard.querySelectorAll(
        this.swatchButtonsSelector
      );
      if (!swatchButtons.length > 0) return;

      const button = productCard.querySelector(this.buttonSelector);
      if (!button) return;

      swatchButtons.forEach((swatchButton) => {
        swatchButton.addEventListener('click', () => {
          if (swatchButton.dataset.preorder) {
            button.textContent = window.themeVariables.strings.preOrderButton;
          } else {
            button.textContent = window.themeVariables.strings.addToCartButton;
          }
        });
      });
    });
  };
}

;// ./src/main.js


// JS goes here







window.addEventListener(
  'load',
  () => {
    const globalComponents = [
      new Product(),
      new CollectionDescription(),
      new CheckboxTermsCart(),
      new PreorderProduct(),
      new QuickBuy(),
      new ProductCard(),
    ];

    globalComponents.forEach((component) => component.init());
  },
  window.supportPassive
);

})();

/******/ })()
;